import {graphql, useFragment} from 'react-relay'

import {usePermission} from '../../../hooks/usePermission'
import type {ProjectId} from '../../../types'
import {Permission} from '../../../types'

import type {CleanupProjectPageUseIsReadOnlyFragment$key} from './__generated__/CleanupProjectPageUseIsReadOnlyFragment.graphql'

const fragment = graphql`
  fragment CleanupProjectPageUseIsReadOnlyFragment on Projects {
    project {
      rawId
    }
  }
`

export function useIsReadOnly(
  projectId: ProjectId,
  readOnlyProjectsKey: CleanupProjectPageUseIsReadOnlyFragment$key | null,
) {
  const {project} = useFragment(fragment, readOnlyProjectsKey) ?? {}
  const isReadOnlyProject = project?.some(item => item?.rawId === projectId)
  const canChangeRules = usePermission(Permission.CHANGE_CLEANUP_RULES, projectId)

  return isReadOnlyProject || !canChangeRules
}
